import { PageOrderEnum } from "@/lib/enum/pageOrder.enum";
import bookingService from "@/services/booking/services/bookingService";
import {
  BookingBookingControllerDeleteOneParamsGen,
  BookingBookingControllerFindAllByPartnerIdParamsGen,
  BookingBookingControllerUpdateParamsGen,
  BookingBookingDetailViewModelGen,
  BookingBookingViewModelGen,
  BookingCreateBookingDtoGen,
  BookingUpdateBookingDtoGen
} from "@/services/booking/v1/data-contracts";
import { Action, getModule, Module, Mutation } from "vuex-module-decorators";
import store from "../../store/VuexPlugin";
import { BasePagination, FilterTypes, IPaginationFilterListElement } from "./base-pagination.store";

@Module({
  dynamic: true,
  namespaced: true,
  name: "booking",
  store
})
export class BookingStore extends BasePagination<
  BookingBookingViewModelGen,
  BookingBookingControllerFindAllByPartnerIdParamsGen
> {
  protected _pageOrder: PageOrderEnum = PageOrderEnum.DESCENDING;
  protected _itemsPerPage = 100;
  protected _totalPages = 0;
  protected _paginationList: BookingBookingViewModelGen[] = [];
  protected _currentPage = 1;
  protected _totalItems = 0;
  protected _isLoadAll = false;
  filterOptions: IPaginationFilterListElement[] = [
    { key: "resourceId", type: FilterTypes.OBJECT_ID },
    { key: "serviceId", type: FilterTypes.OBJECT_ID },
    { key: "partnerId", type: FilterTypes.OBJECT_ID },
    { key: "startInSeconds", type: FilterTypes.NUMBER },
    { key: "durationInSeconds", type: FilterTypes.NUMBER },
    { key: "_id", type: FilterTypes.OBJECT_ID }
  ];

  @Action
  protected async loadDocuments(data: BookingBookingControllerFindAllByPartnerIdParamsGen): Promise<any> {
    return bookingService.findAllByPartner(data);
  }

  private _booking: BookingBookingViewModelGen | null = null;

  get booking() {
    return this._booking;
  }

  @Mutation
  mutateBooking(booking: BookingBookingViewModelGen) {
    this._booking = booking;
  }

  @Action
  async findOneByPartner(data: { partnerId: string; id: string }): Promise<BookingBookingDetailViewModelGen> {
    const booking = await bookingService.findOneByPartner(data.partnerId, data.id);
    this.context.commit("mutateBooking", booking);
    return booking;
  }

  @Action
  async updateOneByPartner(data: {
    query: BookingBookingControllerUpdateParamsGen;
    data: BookingUpdateBookingDtoGen;
  }): Promise<BookingBookingViewModelGen> {
    const booking = await bookingService.updateOneByPartner(data.query, data.data);
    this.context.commit("mutateBooking", booking);
    return booking;
  }

  @Action
  async createOneByPartner(data: {
    partnerId: string;
    resourceId: string;
    data: BookingCreateBookingDtoGen;
  }): Promise<BookingBookingViewModelGen> {
    const booking = await bookingService.createOneByPartner(data.partnerId, data.resourceId, data.data);
    this.context.commit("mutateBooking", booking);
    return booking;
  }

  @Action
  async removeOneByPartner(data: BookingBookingControllerDeleteOneParamsGen): Promise<BookingBookingViewModelGen> {
    const booking = await bookingService.removeOneByPartner(data);
    this.context.commit("mutateBooking", booking);
    return booking;
  }
}

export const BookingModule = getModule(BookingStore);
